import { enableProdMode } from '@angular/core';
import { platformBrowserDynamic } from '@angular/platform-browser-dynamic';

import { AppModule } from './app/app.module';
import { environment } from './environments/environment';

export function getCustomerUrl() {
  return "https://localhost:4200/#/"
}

export function getBaseUrl() {
  // return "http://192.168.1.12:8085/admin"
  // return "https://f1b7-2401-4900-1c2b-7938-cc44-6c35-6dc7-c2be.ngrok-free.app/admin"
  return "https://mentorapi.checksample.in/admin"
}

export function getBaseImageUrl() {
  // return "http://192.168.1.12:8085/"
  // return "https://f1b7-2401-4900-1c2b-7938-cc44-6c35-6dc7-c2be.ngrok-free.app/"
  return "https://mentorapi.checksample.in/"
}

export function getOpenBaseUrl() {
  // return "http://192.168.1.12:8085/astro"
  // return "https://f1b7-2401-4900-1c2b-7938-cc44-6c35-6dc7-c2be.ngrok-free.app/astro"
  return "https://mentorapi.checksample.in/astro"
}

export function getOpenApiBaseUrl() {
  //  return "http://192.168.1.12:8085/api"
  return "https://mentorapi.checksample.in/api"
}

const providers = [
  { provide: 'CUSTOMER_URL', useFactory: getCustomerUrl, deps: [] },
  { provide: 'BASE_URL', useFactory: getBaseUrl, deps: [] },
  { provide: 'OPEN_BASE_URL', useFactory: getOpenBaseUrl, deps: [] },
  { provide: 'BASE_IMAGE_URL', useFactory: getBaseImageUrl, deps: [] },
  { provide: 'BASE_API_URL', useFactory: getOpenApiBaseUrl, deps: [] },
]

if (environment.production) {
  enableProdMode();
}

platformBrowserDynamic(providers).bootstrapModule(AppModule)
  .catch(err => console.error(err));
